import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './_images/official-qr.jpg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-47d496e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-service-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "info-item"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-header" }, "在线客服 (早8:00-晚22:30)", -1))
const _hoisted_4 = { class: "info-content online-service" }
const _hoisted_5 = {
  key: 1,
  class: "info-item"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-header" }, "联系我们", -1))
const _hoisted_7 = { class: "info-content" }
const _hoisted_8 = { class: "cm-ui-mt5" }
const _hoisted_9 = {
  key: 2,
  class: "info-item"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-header" }, "官方邮箱", -1))
const _hoisted_11 = { class: "info-content" }
const _hoisted_12 = {
  key: 3,
  class: "info-item"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-header" }, "官方公众号", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-content official-qr" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((_ctx.IS_MING_TING_SUBJECT || _ctx.IS_AGENT_GENERAL_SUBJECT) && !_ctx.IS_PRIVATE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              icon: "el-icon-service",
              circle: "",
              onClick: _ctx.clickOnlineService
            }, {
              default: _withCtx(() => [
                _createTextVNode("立即接通")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.IS_AGENT_GENERAL_SUBJECT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, "售前电话 " + _toDisplayString(_ctx.CURRENT_PROJECT_SUBJECT.phone_pre_sale), 1),
            _createElementVNode("div", _hoisted_8, "售后电话 " + _toDisplayString(_ctx.CURRENT_PROJECT_SUBJECT.phone_after_sale), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.IS_AGENT_GENERAL_SUBJECT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, _toDisplayString(_ctx.CURRENT_PROJECT_SUBJECT.mail), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.IS_MING_TING_SUBJECT || _ctx.IS_AGENT_GENERAL_SUBJECT)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
      : _createCommentVNode("", true)
  ]))
}